var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 7.5C16.5001 9.98528 14.4854 12 12.0001 12C9.51479 12 7.50007 9.98528 7.50007 7.5C7.50007 5.01472 9.51479 3 12.0001 3C14.4854 3 16.5001 5.01472 16.5001 7.5ZM14.1001 7.5C14.1001 8.6598 13.1599 9.6 12.0001 9.6C10.8403 9.6 9.90007 8.6598 9.90007 7.5C9.90007 6.3402 10.8403 5.4 12.0001 5.4C13.1599 5.4 14.1001 6.3402 14.1001 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9322 21L17.2501 19.7189L19.5671 21L19.1255 18.2869L21.0001 16.3648L18.4094 15.9685L17.2501 13.5L16.0916 15.9685L13.5001 16.3648L15.3747 18.2869L14.9322 21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42829 16.2092C7.91119 17.435 9.10606 18.3 10.5001 18.3C11.1628 18.3 11.7001 18.8373 11.7001 19.5C11.7001 20.1627 11.1628 20.7 10.5001 20.7C8.00355 20.7 5.88483 19.0957 5.11267 16.8654C4.81907 16.0174 5.0655 15.1988 5.5697 14.6394C6.05222 14.1041 6.76321 13.8 7.50007 13.8H10.5001C11.1628 13.8 11.7001 14.3373 11.7001 15C11.7001 15.6627 11.1628 16.2 10.5001 16.2H7.50007C7.47407 16.2 7.44985 16.2035 7.42829 16.2092Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStar);
export default __webpack_public_path__ + "static/media/user_star.ef07ad4ee1a5907f7174f749f102011d.svg";
export { ForwardRef as ReactComponent };